<template src="./Map.html"> </template>


<script>
//import MapLayer from '@/components/Map/MapLayer/MapLayer';
import MapLayer from '@/components/Map/Map/Map';

import { mapState, mapActions } from 'vuex';

export default {
    name: 'ModuleMap',
    // props: {
    //     mapConfig: {
    //         required: true,
    //         type: Object
    //     }
    // },
    components: {
        MapLayer,
    },
    data() {
        return {
            
        }
    },
    computed: {

        ...mapState({
            menuConfig: state => state.menuSettings,
            mapConfigOne: state => state.mapConfigOne,
            mapConfigTwo: state => state.mapConfigTwo,
        }),

        getMapParams() {
            //if (this.mapConfig == undefined) return this.mapConfig;
            //console.log('getMapParams: ', {...{ map1: this.mapConfigOne }, ...{ map2: this.mapConfigTwo }});
            // if (this.mapConfigOne.layer ==  "")
            //     this.setMapConfig();
            return { ...{ map1: this.mapConfigOne }, ...{ map2: this.mapConfigTwo } };
        }
    },
    methods: {
        
        ...mapActions({
            setMapOne: 'setMapConfigOne',
            setMapTwo: 'setMapConfigTwo',
        }),

        // setMapConfig() {
        //     console.log('setMapConfig')

        //     let map1 = {
        //         url: 'https://cloud.agroclimate.org/aws?geoid=' + this.menuConfig.geoid + '&band=1' + '&period=' + this.menuConfig.period.period + "&date=20210713",
        //         layer: this.menuConfig.variable.id,
        //         visibility: true
        //     };

        //     let map2 = {
        //         url: '',
        //         layer: '',
        //         visibility: false
        //     };


        //     this.setMapOne(map1);
        //     this.setMapTwo(map2);
        // }
    },
}
</script>

<style lang="scss" src="./Map.scss"> </style>